import React, { useState } from 'react';
import DocumentViewer from './DocumentViewer';

function PdfViewer() {
  const buttons = [
    { label: '2025 Annual Budget', image: '2025annualbudget.png', folder: 'annualbudget2025', pages: 11 },
    { label: '2024 Annual GAD Accomplishment Report', image: '2024annualgadaccomplishmentreport.png', folder: '2024annualgadaccomplishmentreport', pages: 11 },
    { label: '2025 Annual Procurement Plan', image: '2025annualprocurementplan.png', folder: '2025annualprocurementplan', pages: 150 },
    { label: '2024 Supplemental Procurement Plan', image: '2024supplementalprocurementplan.png', folder: '2024supplementalprocurementplan', pages: 69 },
    { label: 'Statement of Indebtedness, Payments and Balances (SIPB)', image: '2025sipb.png', folder: 'sipbq12025', pages: 1 },
    { label: 'Statement of Receipts and Expenditures', image: '2025sre.png', folder: '1qsre', pages: 2 },
    { label: 'SEF Utilization', image: '2025sefu.png', folder: '2025sefu', pages: 1 },
    { label: 'Trust Fund Utilization', image: '2025tfu.png', folder: '2025tfu', pages: 6 },
    { label: 'Manpower Complement', image: '2025mpc.png', folder: '2025mpc', pages: 1 },
    { label: 'Unliquidated Cash Advances', image: '2025uca.png', folder: '2025uca', pages: 7 },
    { label: 'Utilization of the 20% of the National Tax Allotment', image: '2025tax.png', folder: '2025tax', pages: 1 },
    { label: 'Quarterly Statement of Cash Flow', image: '2025cashflow.png', folder: '2025cashflow', pages: 1 },
    { label: 'Bid Results on Civil Works, Goods and Services, And Consulting Services', image: '2025bidworks.png', folder: '2025bidworks', pages: 18 },
    { label: 'Local Disaster Risk Reduction and Management (LDRRM) Fund Utilization', image: '2025disaster.png', folder: '2025disaster', pages: 2 },
  ];

  const [activeIndex, setActiveIndex] = useState(null);
  const activeButton = buttons[activeIndex];

  if (activeButton?.folder) {
    return (
      <DocumentViewer
        folder={activeButton.folder}
        totalPages={activeButton.pages}
        label={activeButton.label}
        onBack={() => setActiveIndex(null)}
      />
    );
  }

  return (
    <div className="w-full h-full p-4">
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-7 gap-4">
        {buttons.map((item, index) => (
          <button
            key={index}
            onClick={() => setActiveIndex(index)}
            className="flex flex-col border border-gray-300 hover:bg-gray-100 text-black rounded-lg shadow-md"
          >
            <div
              style={{
                backgroundColor: '#2563eb', // Same as Tailwind bg-blue-600
                width: '100%',
                padding: '8px',
                minHeight: '60px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                borderTopLeftRadius: '0.5rem',
                borderTopRightRadius: '0.5rem',
              }}
            >
              <span
                style={{
                  color: '#fff',
                  textAlign: 'center',
                  fontSize: '14px',
                  fontWeight: 'bold',
                  lineHeight: '1.2',
                }}
              >
                {item.label}
              </span>
            </div>
            <div className="aspect-square flex items-center justify-center p-4">
              <img
                src={`/${item.image}`}
                alt="Icon"
                className="w-full h-full object-contain"
              />
            </div>
          </button>
        ))}
      </div>
    </div>
  );
}

export default PdfViewer;
